import React from "react";

function Title({ title, classNames = "" }) {
    return (
        <span
            className={`title text-4xl lg:text-6xl text-center uppercase ${classNames}`}
        >
            {title}
        </span>
    );
}

export default Title;
